<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Games from "@/services/Games";
    import Customers from '@/services/Customers';
    import modalAddPoll from "@/components/modals/games/ModalAddPoll.vue";
    import modalEditPoll from "@/components/modals/games/ModalEditPoll.vue";
    import Swal from "sweetalert2";
    import Monitor from "@/services/Monitor";

    export default {
        components: {
          Layout,
          PageHeader,
          modalAddPoll,
          modalEditPoll
        },
        page: {
            title: "Poll",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
         data() {
            return {
                selectedPollData:null,
                modalGropuData:null,
                isAuthorized: false,
                error: null,
                filterData: false,
                tableData: [],
                modalData:[],
                title: "Poll",
                items: [
                    {
                        text: "Fanzone",
                        href: "#",
                    },
                    {
                        text: "Poll",
                        active: true,
                    },
                ],
                filterInput: {
                    name: '',
                    gender: [],
                    company_id: '',
                    userStatus: [],
                },
                isBusy: false,
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "created_on",
                sortDesc: true,
                fields: [
                    {
                        key: "question",
                        label: "Question",
                        sortable: true,
                    },
                    {
                      key: "active_from",
                      label: "Active From",
                      sortable: true,
                    },
                    {
                        key: "active_to",
                        label: "Active To",
                        sortable: true,
                    },
                    {
                      key: "image",
                      label: "Image",
                      sortable: true,
                    },
                    {
                    key: "recipient",
                    label: "Recipient",
                    sortable: true,
                  },
                    {
                      key: "statistics",
                      label: "Total Votes",
                      sortable: true,
                    },
                    {
                        key: "min_answers",
                        label: "Minimum Answers",
                        sortable: true,
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                    },
                    "action"
                ],
            };
        },

        methods: {



            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },


            modalAddNewPoll(data){
                this.$bvModal.show('add_new_poll')
                this.modalGropuData = data;
            },

            modalEditPoll(data,groupData){
              this.$bvModal.show('edit_poll');
              this.selectedPollData = data;
              this.modalGropuData = groupData;
            },
            async fetchGroups() {
            try {
              const response = await Customers.getCustomersGroups()
              const rawGroups = Array.isArray(response?.data?.data) ? response.data.data : []
              this.groups = rawGroups
                .map((group) => ({
                  value: group.group_id ?? group.id ?? group.value ?? null,
                  text: group.name ?? group.group_name ?? group.text ?? '',
                }))
                .filter((group) => group.value && group.text)
            } catch (error) {
              this.groups = []
            }
          },
            async getPolls(){
                try {
                    this.filterData = true;
                    this.toggleBusy();
                    // var filters = this.getFilters()
                    const response = await Games.getPolls('type=poll');
                    this.tableData = response.data.data
                    this.totalRows = this.tableData.length
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                } finally {
                    this.toggleBusy();
                }
            },
          async deletePoll(id) {
            try {

              const confirmation = await Swal.fire({
                title: 'Delete Poll?',
                text: "This Poll  will be deleted!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
              });
              if (confirmation.isConfirmed) {
                const response = await Games.deletePoll(id);
                if (response.data.success) {
                  this.getPolls();
                  Swal.fire('Deleted!', 'Poll has been deleted.', 'success');
                } else {
                  Swal.fire('Error', 'Failed to delete Poll', 'error');
                }
              }
            } catch (error) {
              Swal.fire('Error', 'Failed to delete Poll', 'error');
              console.error('Error deleting Poll:', error);
            }
          },




            // getFilters(){
            //     var filter_string = '?limit=1000';
            //     filter_string += (this.filterInput.name) ? '&name='+this.filterInput.name : "";
            //     filter_string += (this.filterInput.company_id) ? '&company_id='+this.filterInput.company_id : "";
            //     return filter_string = filter_string.substring(1);
            // },



        },
        mounted() {
            this.getPolls();
            this.fetchGroups()
        },
        middleware: "authentication",
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <div class="row">
            <div class="col-12">

                <div class="card" v-show="filterData">
                    <div class="card-body">
                            <div>
                                <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light me-3"
                                   @click="modalAddNewPoll(groups)">
                                    <i class="mdi mdi-plus me-2"></i>
                                    Create New Poll
                                </a>
                            </div>
                        <div class="row mt-2">
                            <div class="col d-inline-flex align-items-center" >
                                <h4 class="card-title m-0">Total Polls: {{totalRows}}</h4>
                            </div>
                        </div>


                        <div class="row mt-4" v-show="filterData">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0" v-show="filterData">
                            <b-table
                                :items="tableData"
                                :busy="isBusy"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                @filtered="onFiltered"
                                show-empty
                                empty-text="No Data Found"
                            >

                              <template v-slot:cell(active_from)="data">
                                <span
                                    style="font-size:14px;"
                                    class="badge"
                                    :class="{
                                    'bg-danger': data.item.status === 'past' || data.item.status === 'incomplete',
                                    'bg-success': data.item.status === 'active' || data.item.status === 'future',
                                  }"
                                >{{data.item.active_from}}</span>
                              </template>
                              <template v-slot:cell(active_to)="data">
                                <span
                                    style="font-size:14px;"
                                    class="badge"
                                    :class="{
                                    'bg-danger': data.item.status === 'past' || data.item.status === 'incomplete',
                                    'bg-success': data.item.status === 'active' || data.item.status === 'future',
                                  }"
                                >{{data.item.active_to}}</span>
                              </template>
                              <template v-slot:cell(status)="data">
                                <span
                                    style="font-size:14px;"
                                    class="badge"
                                    :class="{
                                   'bg-danger': data.item.status === 'past' || data.item.status === 'incomplete',
                                    'bg-success': data.item.status === 'active' || data.item.status === 'future',
                                  }"
                                >{{data.item.status}}</span>
                              </template>


                              <template  v-slot:cell(image)="data">
                                <img v-if="data.item.image !== null && data.item.image !== ''"  :src="data.item.image" style="width: 80px;" alt="Poll Image" />
                                <img v-else src="@/assets/images/image_not_found.png" style="width: 80px;" alt="Poll Image"/>
                              </template>

                              <template  v-slot:cell(statistics)="data">
                                <span>{{data.item.statistics.total_votes}}</span>

                              </template>

                              <template v-slot:cell(action)="data">
                                <ul class="list-inline mb-0 d-flex align-items-center gap-1">
                                  <li class="list-inline-item">
                                    <a :href="`/games/poll/statistics/${data.item.id}`" title="View Answer Statistics">
                                      <i  style="color: #5b73e8;" class="uil uil-eye font-size-18"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a v-if="data.item.status != 'active' && data.item.status != 'past'" title="Edit Poll" @click="modalEditPoll(data.item, groups)" href="javascript:void(0)">
                                      <i class="uil uil-pen font-size-18 text-primary"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a v-if="data.item.status != 'active' && data.item.status != 'past'" title="Delete Poll" @click="deletePoll(data.item.id)" href="javascript:void(0)">
                                      <i class="uil uil-trash-alt font-size-18 text-danger"></i>
                                    </a>
                                  </li>
                                </ul>
                              </template>


                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="row" v-show="filterData">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="totalRows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
          <modalAddPoll @onRefresh="getPolls" :group-options="modalGropuData" ></modalAddPoll>
          <modalEditPoll @onRefresh="getPolls" :pollData="selectedPollData" :group-options="modalGropuData"></modalEditPoll>
    </Layout>
</template>
